export const SUCCESS_DATA = "SUCCESS_DATA";
export const ERROR_DATA = "ERROR_DATA";
export const RESET_DATA = "RESET_DATA";
export const LOADING_DATA = "LOADING_DATA";
